var map = {
	"./http.js": 201,
	"./standalone.js": 433,
	"./ws.js": 434
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;


//////////////////
// WEBPACK FOOTER
// ./javascript/core/connections ^\.\/.*\.js$
// module id = 513
// module chunks = 0